import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function HandleDeletePopup() {
  const dispatch = useAppDispatch();
  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.successPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.successTextWrapper}>
        <img src={success} alt="иконка успех" />
        <h2 className={styles.successTitle}>Ваш запрос успешно создан!</h2>
        <h3 className={styles.successSubTitle}>Вы создали запрос на удаление</h3>
      </div>
      <RedButton text="Хорошо" onClick={handleClosePopup} width={308} height={54} />
    </div>
  );
}

export default HandleDeletePopup;
